import { Link } from 'react-router-dom';
import { getRecentArticles } from '@/mocks/articles';

export default function HotArticles() {
  const recentArticles = getRecentArticles(4);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-10 md:mb-14 gap-3">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
              热门文章推荐
            </h2>
            <p className="text-sm md:text-base text-foreground-600 mt-2">
              精选实用指南，发现更多优质数字工具与资源
            </p>
          </div>
          <Link
            to="/category/xuexi-pingtai"
            className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium cursor-pointer whitespace-nowrap"
          >
            查看更多
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {recentArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-300 hover:shadow-md transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-[10px] md:text-xs text-accent-600 bg-accent-100 px-1.5 py-0.5 rounded-md whitespace-nowrap">
                    {article.tags[0]}
                  </span>
                  <span className="text-[10px] md:text-xs text-foreground-400">{article.date}</span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between mt-3 pt-3 border-t border-background-200/60">
                  <span className="text-[10px] md:text-xs text-foreground-400">{article.author}</span>
                  <span className="text-[10px] md:text-xs text-foreground-400">
                    <i className="ri-time-line mr-1"></i>
                    {article.readTime}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}